import * as Scrivito from "scrivito";
import defaultPageAttributes from "../_defaultPageAttributes";

const TrainingCatalogPage = Scrivito.provideObjClass("TrainingCatalogPage", {
  attributes: {
    ...defaultPageAttributes,
    body: [
      "widgetlist",
      { only: ["SectionContentWidget", "PageHeaderWidget"] },
    ],
    introduction: "html",
  },
  extractTextAttributes: ["body", "title", "segmentName", "introduction"],
});

export default TrainingCatalogPage;
